import { cn } from '@/lib/utils';
import { useAudio } from '@chainlit/react-client';
import { useRef, useEffect } from 'react';

import { IAudioElement } from '@chainlit/react-client';

const AudioElement = ({ element }: { element: IAudioElement }) => {
  const { audioConnection } = useAudio();
  const audioRef = useRef<HTMLAudioElement>(null);
  const hasAutoPlayed = useRef(false);

  if (!element.url) {
    return null;
  }

  // Auto-play only once on initial render, not on subsequent re-renders
  useEffect(() => {
    if (element.autoPlay && !hasAutoPlayed.current && audioRef.current) {
      hasAutoPlayed.current = true;
      audioRef.current.play().catch((err) => {
        // Browser may block autoplay, ignore the error
        console.debug('Audio autoplay blocked:', err);
      });
    }
  }, [element.autoPlay]);

  return (
    <div className={cn('space-y-2', `${element.display}-audio`)}>
      <p className="text-sm leading-7 text-muted-foreground">{element.name}</p>
      <audio ref={audioRef} controls src={element.url} />
    </div>
  );
};

export { AudioElement };
